import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function EditTagOutlineIcon(props: IconProps): JSX.Element {
  const { width, height } = props;
  return (
    <svg
      id="Icon_Button_-_Edit_Tags"
      data-name="Icon Button - Edit Tags"
      xmlns="http://www.w3.org/2000/svg"
      width={width || "32"}
      height={height || "32"}
      viewBox="0 0 32 32"
    >
      <rect
        id="Rectangle_1955"
        data-name="Rectangle 1955"
        width={width || "32"}
        height={height || "32"}
        rx="5"
        fill="#fff"
      />
      <path
        id="Union_32"
        data-name="Union 32"
        d="M12552.028,17955a3.037,3.037,0,0,1-1.911-.752l-5.335-5.309a3.122,3.122,0,0,1-.626-.959,2.879,2.879,0,0,1-.14-1.1v-5.434a2.262,2.262,0,0,1,.671-1.654,2.6,2.6,0,0,1,1.681-.793h5.529a4.175,4.175,0,0,1,1.136.139,2.379,2.379,0,0,1,.7.465l5.078,5.01a3.306,3.306,0,0,1,.424,4.684l-2.46,2.469-2.632,2.586a3.445,3.445,0,0,1-1.97.648C12552.123,17955,12552.073,17955,12552.028,17955Zm-6.174-14.131a1.964,1.964,0,0,0-.252,1.051v4.92a1.8,1.8,0,0,0,.14.73,3.377,3.377,0,0,0,.554.611l4.357,4.354a2.1,2.1,0,0,0,1.474.848h.022a1.978,1.978,0,0,0,1.424-.7l3.957-3.951a1.818,1.818,0,0,0,0-3.092l-4.605-4.561a1.429,1.429,0,0,0-.415-.359,1.394,1.394,0,0,0-.5-.1h-4.921s-.117-.01-.275-.01C12546.535,17940.607,12546.039,17940.641,12545.854,17940.865Zm1.834,2.92a1.217,1.217,0,1,1,1.217,1.217A1.218,1.218,0,0,1,12547.688,17943.785Z"
        transform="translate(-12536.011 -17931)"
        fill="#979797"
      />
    </svg>
  );
}
